import * as React from "react";
import { IconProps } from "../types";

const Paperclip1Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M7.25 12V5.25C7.25 4.83579 7.58579 4.5 8 4.5C8.41421 4.5 8.75 4.83579 8.75 5.25V12C8.75 12.4138 9.08621 12.75 9.5 12.75C9.91379 12.75 10.25 12.4138 10.25 12V5C10.25 3.75721 9.24279 2.75 8 2.75C6.75721 2.75 5.75 3.75721 5.75 5V12C5.75 14.0708 7.42921 15.75 9.5 15.75C11.5708 15.75 13.25 14.0708 13.25 12V5.25C13.25 4.83579 13.5858 4.5 14 4.5C14.4142 4.5 14.75 4.83579 14.75 5.25V12C14.75 14.8992 12.3992 17.25 9.5 17.25C6.60079 17.25 4.25 14.8992 4.25 12V5C4.25 2.92879 5.92879 1.25 8 1.25C10.0712 1.25 11.75 2.92879 11.75 5V12C11.75 13.2422 10.7422 14.25 9.5 14.25C8.25779 14.25 7.25 13.2422 7.25 12Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default Paperclip1Icon;
